import React from 'react';
import aboutImage from '../../assets/images/backgrounds/background_about-b.png';
import TextContentHeader from './TextContentHeader';
import CallToAction from '../Misc/CallToAction';
import TextContentInner from './TextContentInner';
import Art from '../Misc/Art';
import illustration from '../../assets/images/art_2.png';
import aboutImage4 from '../../assets/images/about-4.webp';
import aboutImage5 from '../../assets/images/about-5.webp';

import { TextContentData } from '../../Data/TextContent';

function TextContent() {
  return (
    <div className="text-content">
      <div
        className="text-content-wrapper position-relative bg-black"
        style={{
          backgroundImage: `url(${aboutImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <TextContentHeader heading="The fastest way to understand is to experience it." />
        <TextContentInner content={TextContentData} />

        <CallToAction
          wrapperClass="text-content-footer bg-black pt-0 pb-0"
          headingClass="light-1"
          heading={
            <>
              Have an idea?
              <br />
              Let’s explore it together.
            </>
          }
          buttonText="Contact Us"
          buttonLink="/Contact"
          buttonType="1"
        />
        <Art art={illustration} type="2" />
      </div>
      <br />
      <br />
      <div className="single-image-wrapper">
        <div className="single-image">
          <img src={aboutImage4} alt="Studio NORCAT accolades and awards" loading="lazy" decoding="async" />
        </div>
        <div className="single-image">
          <img src={aboutImage5} alt="A poster of PANTONE 185, Studio NORCAT's branded colour" loading="lazy" decoding="async" />
        </div>
      </div>
      <br />
      <br />
      {/* remove this since blogimage is now the background */}
      {/* <div className="single-image">
        <img src={blogimage} alt="generic" />
      </div> */}
    </div>
  );
}

export default TextContent;
